module.exports = __webpack_public_path__ + "static/media/lc_profile_icon.fa4986b7.svg";